import React from 'react';
import { ScarcityBanner } from '../components/ScarcityBanner';
import { PriceAlert } from '../components/PriceAlert';
import { HeroLP1 } from '../components/HeroLP1';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPageLP3() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1403">
      <ScarcityBanner data-id="element-1404" />
      <PriceAlert data-id="element-1405" />
      <HeroLP1 data-id="element-1406" />
      <Testimonial data-id="element-1407" />
      <ProblemSolution data-id="element-1408" />
      <ValueStack data-id="element-1409" />
      <ModuleBreakdown data-id="element-1410" />
      <Guarantee data-id="element-1411" />
      <PricingSection data-id="element-1412" />
      <Footer data-id="element-1413" />
      <RecentPurchaseToast data-id="element-1414" />
    </div>;
}